import { Link } from "react-router-dom";

// Zebaa wordmark: emerald for light backgrounds, white for dark ones (footer, admin sidebar).
export const LOGO_URL = "/zebaa-logo.png";
export const LOGO_WHITE_URL = "/zebaa-logo-white.png";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo">
    <img
      src={LOGO_URL}
      alt="Zebaa"
      className="block h-6 sm:h-7 w-auto"
      loading="eager"
      decoding="async"
    />
  </Link>
);
